import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'ecp-menu',
  templateUrl: './ecp-menu.component.html',
  styleUrls: ['./ecp-menu.component.css'],
  animations: [
    trigger('displayState', [
      state('none', style({
        height: 0, display: 'none', opacity: '0',
      })),
      state('block', style({
        height: '*', display: 'block', opacity: '1',
      })),
      transition('none => block', animate('100ms linear')),
      transition('block => none', animate('100ms linear'))
    ])
  ]
})
export class EcpMenuComponent implements OnInit {
  @Input() ecpTheme: 'default' | 'white' = 'default';

  @Input() ecpCustomScaling: boolean; // èªå®ä¹ä¼¸ç¼©,true å¯ä»¥ç¼©æ¾ï¼false ç¦æ­¢ç¼©æ¾
  @Input() ecpStyle: object = {};
  @Input() ecpMenuList: Array<any> = [];
  @Input() ecpDefaultUrl: string; // ç³»ç»å½åéä¸­è·¯ç±
  @Output() ecpGoTo = new EventEmitter();
  menuStatus = 'off';
  hoverId = 0; // å½åå·²éä¸­
  selectId = 0; // å½åé¼ æ éä¸­
  thisMenuId = 0; // å½åéä¸­å­èå
  hisHover = 0; // åå²éä¸­èå,æ¶ç¼©æ¶è®°å½ï¼å±å¼æ¶ä½¿ç¨


  /*

    menus: Array<any> = [
      {
        'name': 'åºæ¬ç»ä»¶',
        'uri': '',
        'iconuri': 'pipe_area',
        'child': [
          {
            'name': 'å·¦è¾¹å¯¼èª',
            'uri': 'navBarPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'é¡¶é¨å¯¼èª',
            'uri': 'topNavPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'é¡µé¢å·¦è¾¹å¯¼èª',
            'uri': 'pageLeftNavPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'å¼å³åæ¢',
            'uri': 'switchPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'é¢åå±',
            'uri': 'breadCrumbPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'æ­¥éª¤æ¡',
            'uri': 'stepsInfo',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'å·¥å·æ¡',
            'uri': 'toolBarPage',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'æç´¢æ¨¡å',
            'uri': 'seachModulePage',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'å¼¹åºè¯¦æ',
            'uri': 'openDetailsInfo',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'å¼¹åºè¯¦æ2',
            'uri': 'openDetailsInfo2',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'å°å¾ç¨ç»ä»¶',
            'uri': 'dotRipplePage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'ä¾§è¾¹æ å¼¹åº',
            'uri': 'popupSidebarPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'æ ç­¾é¡µ',
            'uri': 'tabsPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'ç¶ææ¡',
            'uri': 'statusBarPage',
            'iconuri': '',
            'child': null
          }

        ]
      },
      {
        'name': 'å¸å±ç»ä»¶',
        'uri': '',
        'iconuri': 'pipe_area',
        'child': [
          {
            'name': 'å¸å±æ¼ç¤º',
            'uri': 'layoutDemoPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'ä¸ä¸­ä¸',
            'uri': 'flexTopCenterBottom',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'å·¦ä¸­å³',
            'uri': 'flexleftCenterRight',
            'iconuri': '',
            'child': null
          }
        ]
      },
      {
        'name': 'æ°æ®å±ç¤º',
        'uri': '',
        'iconuri': 'pipe_area',
        'child': [
          {
            'name': 'ç»å½çé¢',
            'uri': 'loginPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'ç³»ç»åæ¢',
            'uri': 'homePage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'é¡µé¢æ¼ç¤º1',
            'uri': 'pageDemo',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'é¡µé¢æ¼ç¤º3',
            'uri': 'pageDemo3',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'é¡µé¢æ¼ç¤º2',
            'uri': 'detailsStyle1',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'è¡¨æ ¼å±ç¤º1',
            'uri': 'dataDemoPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'è¡¨æ ¼å±ç¤º',
            'uri': 'tablePage',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'å¾æ æ¼ç¤º',
            'uri': 'iconPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'æ ç­¾é¡µï¼ä¼ éæ¨¡æ¿ï¼',
            'uri': 'ecpTabset',
            'iconuri': '',
            'child': null
          },
          {
            'name': '404/500é¡µé¢',
            'uri': 'httpPage',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'çæå¸å',
            'uri': 'generateBillPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'å¼¹çªæ¼ç¤º',
            'uri': 'waterConsumptionAnalysisPopup',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'ç»ä»¶èå¨',
            'uri': 'pageDemo2',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'è°åº¦ä¸­å¿',
            'uri': 'dispatchPage',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'æ§å¶å°ä¸»é¡µ',
            'uri': 'consolePage',
            'iconuri': '',
            'child': null
          }
        ]
      },
      {
        'name': 'å³äº',
        'uri': 'about',
        'iconuri': 'pipe_report',
        'child': []
      }
    ];

  */

  constructor(private router: Router) {
  }

  ngOnInit() {

    // console.log('this.ecpMenuList', this.ecpMenuList);
    // æ ¹æ®defaultUrlæ¾å°å½åéä¸­çèå
    this.getAllJson(this.ecpMenuList, '', '>', this.ecpMenuList, 0);

    this.menuStatus = 'on';


  }

  ngOnChanges() {
    // æ ¹æ®defaultUrlæ¾å°å½åéä¸­çèå
    this.getAllJson(this.ecpMenuList, '', '>', this.ecpMenuList, 0);
  }

  // éåèåJSON
  getAllJson(jsons, name, sign, parent, parentIndex) {
    const self = this;
    if (name === '' || name === undefined) {
      name = 'json';
    }

    for (let i in jsons) {
      // console.log('index', jsons[i], parentIndex);
      let k = name + sign + i;
      if (!(jsons[i] instanceof Object)) {

        // console.log(k + ' = ' + jsons[i]); // å¦æä¸æ¯Objectåæå°é®å¼

        // console.log('parentIndex*******', parentIndex);
        // console.log('jsons[i] ------------', jsons[i]);
        // console.log('this.defaultUrl------------', this.defaultUrl);

        if (jsons[i] === this.ecpDefaultUrl) {

          for (const kk in this.ecpMenuList) {
            // console.log('this.ecpMenuList[kk].uri', this.ecpMenuList[kk].uri);
            // console.log('parentparentparentparentparentparent', parent[parentIndex].uri);
            if (this.ecpMenuList[kk].havechild === true) {
              if (this.ecpMenuList[kk].child === parent) {
                //   console.log('ç¸åç00000000000000000000000000000', parentIndex);
                // console.log('this.ecpMenuList[kk].child11', this.ecpMenuList[kk].child);
                // å¹éå½åé¡µé¢è·¯ç±å¼åï¼è®¾ç½®èåéä¸­ç¶æ
                self.hoverId = Number(kk);
                self.selectId = Number(kk);
                self.hisHover = Number(kk);
                if (self.ecpCustomScaling == null) {
                  self.ecpCustomScaling = true;
                } else if (this.ecpCustomScaling === false) {
                  self.menuStatus = 'on';
                }
                self.thisMenuId = parentIndex;

              }
            } else {

              if (this.ecpMenuList[kk].uri === parent[parentIndex].uri) {

                self.hoverId = Number(kk);
                self.selectId = Number(kk);
                self.hisHover = Number(kk);
                if (self.ecpCustomScaling == null) {
                  self.ecpCustomScaling = true;
                } else if (this.ecpCustomScaling === false) {
                  self.menuStatus = 'on';
                }

              }

            }
          }
        }

      } else {
        this.getAllJson(jsons[i], k, sign, jsons, i); // å¦ææ¯Objectåéå½
      }
    }
  }


  // èåéä¸­
  hoverMenu(id) {
    if (this.hoverId === id) {
      this.hoverId = null;
    } else {
      this.hoverId = id;
    }
  }

  // ç§»ä¸å»ç
  selectMenu(id) {
    this.selectId = id;

  }

  // æ¸é¤éä¸­
  cleanSel() {
    this.selectId = null;
  }

  // å±å¼
  on() {
    const self = this;
    if (self.menuStatus === 'off') {
      self.hoverId = self.hisHover;

      self.menuStatus = 'on';

    }
  }

  // æ¶ç¼©
  off() {
    const self = this;
    self.hisHover = self.hoverId;
    if (self.ecpCustomScaling === true) {
      this.menuStatus = 'off';
    }
  }

  showChildMenu(i) {
    if (i === this.hoverId && this.menuStatus === 'on') {
      return 'block';
    } else {
      return 'none';
    }
  }


  selectedApp(obj: string, childHoverId?: number) {
    const self = this;
    this.ecpGoTo.emit(obj);
    if (childHoverId == null) {
      self.thisMenuId = -1;
    } else {
      self.thisMenuId = childHoverId;
    }
    // console.log('click');
    // self.router.navigate([uri]);
    return false;
  }

}
